const ACTIVE_LINK_OPTIONS = {
  exact: true,
  strict: false,
};

export default ACTIVE_LINK_OPTIONS;
